export default function refDataByKey(key) {
    try {
        let data = JSON.parse(localStorage.getItem(key));
        return data;
    } catch (error) {
        console.error(error);
        throw new Error (`Unable to retrieve reference data for ${key}`);
    }
}